import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { CartContext } from '../../contexts/CartContext';
import {CartIcon} from '../icons';
import styles from './header.module.scss';
import BootstrapCarouselComponent from './bootstrap-carousel.component';





const Header = () => {
    
    const {itemCount} = useContext(CartContext);
   
    

    return ( 
    
        <div className="containerFluid">
            <div className="containerFluid" style={{ color: "white", fontSize:"1.2em", display:"flex", justifyContent: "center", backgroundColor:"#113A77", paddingTop: "10px"}}>
               <BootstrapCarouselComponent />
            </div>
            <header className={styles.header}>
                <div className="containerFluid">
                    <div className="row" style={{margin: '0'}}>
                        <div className="col-xs-12 col-md-3 col-sm-12 " style={{backgroundColor: "#C4C4C4", textAlign: 'center', paddingBottom: "15px"}} >  
                            <img src="/img/livrev2.png"   alt="" style={{width:"90%", height:"100%"}} />
                        </div>          
                        <div className="col-xs-12 col-md-6 col-sm-12 " style={{paddingTop: "20px",}}>
                        <Link to='/' >Nos publications</Link>
                        <Link to='/about'>Nous découvrir</Link>
                        <Link to='/account'>Mon compte</Link>
                        <Link to='/cart'> <CartIcon/> Panier ({itemCount})</Link>
                        </div>
                        {/* <div className="col-xs-12 col-md-3 col-sm-12" style={{backgroundColor: "#C4C4C4", display: 'inline-block', textAlign: 'center', paddingTop: "15px", paddingBottom: "5px"}} >
                            <button variant="outline-primary">BD</button>
                            <button variant="outline-primary">Polars</button>
                            <button variant="outline-primary">Romans</button>
                            <button variant="outline-primary">Tous</button>
                        </div> */}
                    </div>    
                </div>
            </header>
        </div>
    );
}
 
export default Header;